
import Vue, { computed } from 'vue'
import ShipBody from './ShipBody.vue'
import { SET_SELECTED_HATCH_INDEX, DELETE_VESSEL_HATCH, ADD_VESSEL_HATCH } from '@/core/services/store/vesselProfile.module'
import { mapActions, mapGetters } from 'vuex'
import store from '@/core/services/store'
import { VesselHatchType } from "@/types/vesselProfile"
import configs from "@/config/config"
// import Bow from '@/components/vesselOperationMonitoring/assets/Bow.svg'

const SECTION_WIDTH = 70
const TAIL_WIDTH = 105
const WIDTH_20_FOOT_CONTAINER = 35
const WIDTH_40_FOOT_CONTAINER = 65
const HEIGHT_CONTAINER = 10


interface Section {
  id: string
  type: VesselHatchType
  hatchType: VesselHatchType
  hasBayFore: boolean
  bayFore: number
  bayAfter: number
  bay40: number
  hasBay40: boolean
  hasBayAfter: boolean
  underDeck: {
    rowCount: number
  }
  onDeck: {
    rowCount: number
  },
  position:number
}



interface Ship {
  head: Section
  tail: Section
  middle: Section[]
}

export default Vue.extend({
  components: {
    ShipBody: ShipBody
  },
  data: function () {
    return {
      headImage: configs.VUE_APP_BASE_YARDVIEW + "media/svg/vesselProfile/Stern.svg",
      tailImage: configs.VUE_APP_BASE_YARDVIEW + "media/svg/vesselProfile/Bow.svg",
      UnderDeckCellConfig: {},
      SECTION_WIDTH: SECTION_WIDTH,
      TAIL_WIDTH: TAIL_WIDTH,
      selectedHatchIndex: 0,
      isHighlightActive: false,
      VesselHatchType: VesselHatchType,
      windowHeight: window.innerHeight,
      windowWidth: window.innerWidth,
      sternImage: null,
      bowImage: null,
      bodyImage: null,
      cellImage: null,
      fortyFootImage: null,
      ship: {
        head: {
          id: 'head',
          type: 'head',
          position: 0
        },
        middle: [
          {
            id: '001',
            type: VesselHatchType.Hatch,
            bg: '#ffffff00',
            hasBay40: false,
            hasBayAfter: true,
            hasBayFore: true,
            underDeck: {
              rowCount: 2,
            },
            onDeck: {
              rowCount: 3,
            }
          },
        ]
      },
      showContextMenu: false,
      contextMenuX: 0,
      contextMenuY: 0,
      selectedSection: null as Section | null,
    }
  },
  props: {
    data: {
      type: Object,
      default: null
    }
  },
  destroyed() {
    window.removeEventListener('contextmenu', (event) => {
      event.preventDefault()
    })
  },
  methods: {
    getSectionGroupConfig() {
      return {

      }


    },
    getSectionConfig(section: Section, index) {
      return {
        x: - SECTION_WIDTH * index + (TAIL_WIDTH + SECTION_WIDTH * (this.vesselProfileHatches.length - 1)),
        y: 150,
        width: SECTION_WIDTH,
        height: 182,

        // image: thi1s.bodyImage,
        sceneFunc: (context, shape) => {
          context.beginPath()
          context.moveTo(0, 0)
          context.lineTo(SECTION_WIDTH, 0)
          context.lineTo(SECTION_WIDTH, 89)
          context.lineTo(0, 89)
          context.closePath()

          // upper part color
          context.fillStyle = ''
          context.fill()

          // bottom part color
          context.beginPath()
          context.moveTo(0, 89)
          context.lineTo(SECTION_WIDTH, 89)
          context.lineTo(SECTION_WIDTH, 182)
          context.lineTo(0, 182)
          context.closePath()

          context.fillStyle = '#1C5B7C'
          context.fill()


        },

      }
    },
    SeperateLine(y) {
      return {
        x: -10,
        y: y,
        width: SECTION_WIDTH * (this.vesselProfileHatches.length - 1) + TAIL_WIDTH * 3,
        height: 2,
        fill: 'gray',
        strokeWidth: 0.4,
        listening: false,
        stroke: 'gray',
      }
    },
    getDischargeCellConfig(sectionIndex, Xoffset, Yoffset, width) {
      return {
        x: - SECTION_WIDTH * sectionIndex + (TAIL_WIDTH + Xoffset + SECTION_WIDTH * (this.vesselProfileHatches.length - 1)),
        y: Yoffset,
        width: width,
        height: 30,
        fill: 'white',
        strokeWidth: 0.4,
        listening: false,
        stroke: '#black',
      }
    },
    getDischargeDeckValueConfig(section: Section, sectionIndex, Xoffset, Yoffset) {
      return {
        x: - SECTION_WIDTH * sectionIndex + (TAIL_WIDTH + Xoffset + SECTION_WIDTH * (this.vesselProfileHatches.length - 1)),
        y: Yoffset,
        fill: 'black',
        listening: false,
        fontStyle: 'normal',
        fontSize: 12,

      }
    },
    Dischargh() {
      return {
        x: 0,
        y: 370,
        width: WIDTH_20_FOOT_CONTAINER,
        height: 140,
        fill: 'white',
        strokeWidth: 0.4,
        listening: false,
        stroke: '#black',
      }
    },
    DischargeLoadLable(x, y, rotation, title) {
      return {
        x: x,
        y: y,
        fill: 'black',
        listening: false,
        fontStyle: 'normal',
        fontSize: 13,
        text: title,
        rotation: rotation
      }
    },

    getHatchForeLabelsConfig(section: Section, index) {
      return {
        x: - SECTION_WIDTH * index + (TAIL_WIDTH + SECTION_WIDTH * (this.vesselProfileHatches.length - 1)) + SECTION_WIDTH * 6 / 12 + 6,
        y: 20,
        fill: 'blue',
        listening: false,
        fontStyle: 'normal',
        fontSize: 13,
        text: section.hasBayFore ? String(section.bayFore).padStart(2, '0') : '',
      }
    },
    getHatch40FootLabelsConfig(section: Section, index) {
      return {
        x: - SECTION_WIDTH * index + (TAIL_WIDTH + SECTION_WIDTH * (this.vesselProfileHatches.length - 1)) + SECTION_WIDTH * 4 / 12 + 6,
        y: 0,
        fill: 'red',
        listening: false,
        fontStyle: 'normal',
        fontSize: 13,
        text: section.hasBay40 ? String(section.bay40).padStart(2, '0') : '',
      }
    },

    getHatchAfterLabelsConfig(section: Section, index) {
      return {
        x: - SECTION_WIDTH * index + (TAIL_WIDTH + SECTION_WIDTH * (this.vesselProfileHatches.length - 1)) + SECTION_WIDTH * 2 / 12 + 6,
        y: 20,
        fill: 'blue',
        fontStyle: 'normal',
        listening: false,
        fontSize: 13,
        text: section.hasBayAfter ? String(section.bayAfter).padStart(2, '0') : '',
      }
    },
    getDischargeInfoConfig(YIndexOffset, Value) {
      return {
        x: TAIL_WIDTH + SECTION_WIDTH * (this.vesselProfileHatches.length - 1) + 80,
        y: 380 + YIndexOffset * 25,
        fill: 'black',
        fontStyle: 'normal',
        listening: false,
        fontSize: 13,
        text: Value,
      }
    },
    getLoadInfoConfig(YIndexOffset, Value) {
      return {
        x: TAIL_WIDTH + SECTION_WIDTH * (this.vesselProfileHatches.length - 1) + 80,
        y: 550 + YIndexOffset * 25,
        fill: 'black',
        fontStyle: 'normal',
        listening: false,
        fontSize: 13,
        text: Value,
      }
    },


    getHighlightConfig: function (section, sectionIndex) {
      return {
        // x: - SECTION_WIDTH * sectionIndex + TAIL_WIDTH,
        x: - SECTION_WIDTH * sectionIndex + (TAIL_WIDTH + SECTION_WIDTH * (this.vesselProfileHatches.length - 1)),
        y: 0,
        onMouseEnter: function (e: any) {
          const container = e.target.getStage().container()
          container.style.cursor = "crosshair"

        },
        width: SECTION_WIDTH,
        height: 750,
        fill: this.$store.state.selectedHatchIndex === sectionIndex ? '#ff000022' : '#ffffff00',
        onClick: () => {

          // this.selectedHatchId = sectionIndex
          // this.setSelectedHatchId(section.id)


          this.showContextMenu = false
          this.$store.dispatch({ type: 'setSelectedHatchIndex', index: sectionIndex })


          // this.$emit('selectSection', section.id)


          // Add event listener to reset section.bg on click outside of rectangle
          // document.addEventListener('click', (event) => {
          //   const rect = document.querySelector('#bg' + section.id); // Replace with the appropriate selector for your rectangle
          //   
          //   if (!rect.contains(event.target as Node)) {
          //     section.bg = '#ffffff00';
          //   }
          // });
        },
        onContextMenu: () => {
          //  @contextmenu.stop.prevent="handleRightClick(ship.head, $event)
          this.handleRightClick()
        }
      }
    },

    getOnDeckCellConfig: function (section, index, sectionIndex) {


      const x = (() => -SECTION_WIDTH * sectionIndex + (TAIL_WIDTH + SECTION_WIDTH * (this.vesselProfileHatches.length - 1)) + SECTION_WIDTH / 2)()
      const y = (() => 145 - index * HEIGHT_CONTAINER + .3)()
      const width = (() => {
        if (section.hasBayFore) return WIDTH_20_FOOT_CONTAINER
        return 0
      })()
      const height = (() => {
        if (section.hasBayFore) return HEIGHT_CONTAINER
        return 0
      })()


      return {
        x,
        y,
        width,
        height,
        fill: 'white',
        listening: false,
        strokeWidth: 0.4,
        stroke: 'black',
      }

    },



    getOnDeckAfterCellConfig(section: Section, index, sectionIndex) {
      return {
        x: - SECTION_WIDTH * sectionIndex + (TAIL_WIDTH + SECTION_WIDTH * (this.vesselProfileHatches.length - 1)) + SECTION_WIDTH / 2 - WIDTH_40_FOOT_CONTAINER / 2,
        y: 145 - index * HEIGHT_CONTAINER + .3,
        width: (() => {
          if (section.hasBayAfter) return WIDTH_20_FOOT_CONTAINER
          if (section.hasBay40) return WIDTH_40_FOOT_CONTAINER
          return 0
        })(),
        height: (() => {
          if (section.hasBayAfter || section.hasBay40) return HEIGHT_CONTAINER
          return 0
        })(),
        fill: 'white',
        listening: false,
        strokeWidth: 0.4,

        stroke: '#black',
      }
    },

    getUnderDeckCellConfig(section: Section, index, sectionIndex) {
      return {
        x: - SECTION_WIDTH * sectionIndex + (TAIL_WIDTH + SECTION_WIDTH * (this.vesselProfileHatches.length - 1)) + SECTION_WIDTH / 2,
        y: 145 + index * HEIGHT_CONTAINER + .3,
        width: (() => {
          if (section.hasBayFore) return WIDTH_20_FOOT_CONTAINER
          return 0
        })(),
        height: (() => {
          if (section.hasBayFore) return HEIGHT_CONTAINER
          return 0
        })(),
        fill: 'white',
        listening: false,
        strokeWidth: 0.4,
        stroke: '#black',
      }
    },
    getUnderDeckAfterCellConfig(section: Section, index, sectionIndex) {
      return {
        x: - SECTION_WIDTH * sectionIndex + (TAIL_WIDTH + SECTION_WIDTH * (this.vesselProfileHatches.length - 1)) + SECTION_WIDTH / 2 - WIDTH_40_FOOT_CONTAINER / 2,
        y: 145 + index * HEIGHT_CONTAINER + .3,
        width: (() => {
          if (section.hasBayAfter) return WIDTH_20_FOOT_CONTAINER
          if (section.hasBay40) return WIDTH_40_FOOT_CONTAINER
          return 0
        })(),
        height: (() => {
          if (section.hasBayAfter || section.hasBay40) return HEIGHT_CONTAINER
          return 0
        })(),
        fill: 'white',
        listening: false,
        strokeWidth: 0.4,

        stroke: '#black',
      }
    },
    getDeckBridgeConfig(section, sectionIndex) {
      return {
        x: SECTION_WIDTH * sectionIndex + TAIL_WIDTH + WIDTH_20_FOOT_CONTAINER + SECTION_WIDTH / 2 - WIDTH_40_FOOT_CONTAINER / 2,
        y: 50,
        width: 100,
        height: 100,
        fill: 'white',
        strokeWidth: 0.4,
        listening: false,
        stroke: '#black',
      }
    },
    getDeckEngineConfig(section, sectionIndex) {
      return {
        x: SECTION_WIDTH * sectionIndex + TAIL_WIDTH + WIDTH_20_FOOT_CONTAINER + SECTION_WIDTH / 2 - WIDTH_40_FOOT_CONTAINER / 2,
        y: 50,
        width: 100,
        height: 100,
        fill: 'white',
        strokeWidth: 0.4,
        listening: false,
        stroke: '#black',
      }
    },
    getDeckCraneConfig(section, sectionIndex) {
      return {
        x: SECTION_WIDTH * sectionIndex + TAIL_WIDTH + WIDTH_20_FOOT_CONTAINER + SECTION_WIDTH / 2 - WIDTH_40_FOOT_CONTAINER / 2,
        y: 50,
        width: 100,
        height: 100,
        fill: 'white',
        listening: false,
        stroke: '#black',
      }
    },
    open(evt) {
      // updates position of context menu 
      this.contextMenuX = evt.pageX || evt.clientX
      this.contextMenuY = evt.pageY || evt.clientY
      // make element focused 
      // @ts-ignore
      Vue.nextTick(() => this.$el.focus())
    },
    handleRightClick(section: Section, event: any) {
      // event.evt.preventDefault();

      this.showContextMenu = !this.showContextMenu
      this.contextMenuX = event.evt.pageX || event.evt.clientX
      this.contextMenuY = event.evt.pageY || event.evt.clientY
      this.selectedSection = section
    },
       addSection(direction: 'left' | 'right', section: Section) {
          /* const index = this.ship.middle.findIndex((s) => s.id === section.id);
          const newSection: Section = {
            id: `${Date.now()}`, // This should be unique
            type: VesselHatchType.Hatch, // Set the default type to 'hatch'
            position: direction === 'left' ? section.position - 110 : section.position + 110,
            hatchType: VesselHatchType.Blank
          };
    
          if (direction === 'left') {
            this.ship.middle.splice(index, 0, newSection);
          } else {
            this.ship.middle.splice(index + 1, 0, newSection);
          }
    
          this.showContextMenu = false; */
        }, 
     deleteSection(section: Section) {
       this.showContextMenu = false
       this.$store.dispatch({ type: DELETE_VESSEL_HATCH, id: this.selectedHatchData.id })
     },
     addSectionToRight(section: Section) {
       this.showContextMenu = false
       this.$store.dispatch({ type: ADD_VESSEL_HATCH, position: "right" })
     },
     addSectionToLeft(section: Section) {
       this.showContextMenu = false
       this.$store.dispatch({ type: ADD_VESSEL_HATCH, position: "left" })
     },
  },
  watch: {

  },
  computed: {
    vesselProfile() {

      const vesselProfile = this.$store.state.vesselProfile.vesselProfile
      setTimeout(() => this.$forceUpdate(), 10)
      return vesselProfile
    },
    vesselProfileHatches() {
      return this.vesselProfileHatches
    },

    ...mapGetters({
      vesselProfileDischarge: 'getQCVesselProfileDischarge',
      vesselProfileLoads: 'getQCVesselProfileLoads',
      selectedHatchData: 'getSelectedQCHatchData',
      // vesselProfile: 'getSelectedQCHatchData',
      vesselProfileHatches: 'getQCVesselProfileHatches',

    }),

    ...mapActions({
      // setSelectedHatchIndex: SET_SELECTED_HATCH_INDEX,
      // deleteVesselHatch: DELETE_VESSEL_HATCH
    }),
    headConfig() {
      return {
        x: 0,
        y: 150,
        width: TAIL_WIDTH,
        height: 200,
        image: this.sternImage,
      }
    },
    tailConfig() {
      return {
        x: (this.vesselProfileHatches.length ?? 0) * (SECTION_WIDTH) + TAIL_WIDTH,
        y: 120,
        width: TAIL_WIDTH,
        height: 212,
        image: this.bowImage,
      }
    },

    // get position of context menu
    style() {
      return {
        top: this.contextMenuY + 'px',
        left: this.contextMenuX + 'px',
      }
    },
  },

  created() {



  },


  mounted() {
    const sternImage = new window.Image()
    sternImage.src = 'media/svg/vesselProfile/Stern.svg'
    sternImage.onload = () => {
      // set image only when it is loaded
      this.sternImage = sternImage
    }
    const bowImage = new window.Image()
    bowImage.src = 'media/svg/vesselProfile/Bow.svg'
    bowImage.onload = () => {
      this.bowImage = bowImage
    }
    const bodyImage = new window.Image()
    bodyImage.src = 'media/svg/vesselProfile/Body.svg'
    bodyImage.onload = () => {
      this.bodyImage = bodyImage
    }
    const cellImage = new window.Image()
    cellImage.src = 'media/svg/vesselProfile/Cell.svg'
    cellImage.onload = () => {
      this.cellImage = cellImage
    }

    const fortyFootImage = new window.Image()
    fortyFootImage.src = 'media/svg/vesselProfile/Cell.svg'
    fortyFootImage.onload = () => {
      this.fortyFootImage = fortyFootImage
    }


  },
})
